import FilterCheckList from "components/FilterCheckList";
import { useField } from "lib/form";
import React from "react";
import { useFilter } from "services/filter";
import { useCount } from "services/search";
import styled from "styled-components";

const Grid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
`;

const names = {
    PERSONENAUTO: "Personenauto",
    BEDRIJFSWAGEN: "Bedrijfswagen",
    OVERIG: "Overig"
};

export const VoertuigsoortFilter = ({ condensed }) => {
    const filter = useFilter("voertuigsoort");
    const count = useCount("voertuigsoort");
    const [value, , onChange] = useField("voertuigsoorten");

    const options =
        filter.map((option) => ({
            id: option,
            displayName: names[option],
            aantal: count[option]
        })) || [];

    return (
        <Grid>
            <FilterCheckList
                filterId="filter-voertuigsoort"
                options={options}
                value={value || []}
                handleChange={(_, v) => onChange(v)}
                columns={condensed ? 1 : 5}
                datalayerKey="voertuigsoort"
                maxSize={0}
            />
        </Grid>
    );
};
